<div class="form-panel-container list-layout-accessibilities">
    @if (unusedUsers && unusedGroups) {
        <div class="accessibilities" cdkDropListGroup>
            <div class="accessibilities-container">
                @if (!disabled) {
                    <mat-tab-group>
                        <mat-tab label="Utilisateurs" class="tab unused-users-container">
                            <div class="drop-list-container">
                                <div
                                    id="users"
                                    cdkDropList
                                    cdkDropListSortingDisabled
                                    [cdkDropListData]="unusedUsers"
                                    class="drop-list drop-target"
                                    (cdkDropListDropped)="drop($event)"
                                    [cdkDropListDisabled]="disabled">
                                    @for (item of unusedUsers; track item) {
                                        <div class="drop-item user-item" cdkDrag cdkDragPreview>
                                            @if (!disabled) {
                                                <fa-icon [icon]="faGripLinesVertical" class="fa-lg drag-handle" cdkDragHandle></fa-icon>
                                            }
                                            <fa-icon [icon]="faUser" class="fa-1x type"></fa-icon>
                                            <span class="label" [title]="item.account">{{ item.displayName }}</span>
                                        </div>
                                    }
                                </div>
                            </div>
                        </mat-tab>
                        <mat-tab label="Groupes d'Utilisateurs" class="tab unused-groups-container">
                            <div class="drop-list-container">
                                <div
                                    id="groups"
                                    cdkDropList
                                    cdkDropListSortingDisabled
                                    [cdkDropListData]="unusedGroups"
                                    class="drop-list drop-target"
                                    (cdkDropListDropped)="drop($event)"
                                    [cdkDropListDisabled]="disabled">
                                    @for (item of unusedGroups; track item) {
                                        <div class="drop-item group-user-item" cdkDrag cdkDragPreview>
                                            @if (!disabled) {
                                                <fa-icon [icon]="faGripLinesVertical" class="fa-lg drag-handle" cdkDragHandle></fa-icon>
                                            }
                                            <fa-icon [icon]="faUsers" class="fa-1x type"></fa-icon>
                                            <span class="label">{{ item.name }}</span>
                                        </div>
                                    }
                                </div>
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                }
                @if (!disabled) {
                    <div class="drag-buttons-container">
                        @if (!disabled) {
                            <button mat-raised-button class="primary-button move-item" (click)="moveAllInAccessibility()">
                                Tout déplacer
                                <fa-icon
                                    [icon]="faAngleDoubleRight"
                                    class="fa-1x move-item-icon"
                                    matTooltipPosition="right"
                                    matTooltipHideDelay="50"
                                    matTooltipClass="info-tooltip"></fa-icon>
                            </button>
                            <button mat-raised-button class="primary-button move-item" (click)="moveAllInUnusedGroupsOrUsers()">
                                <fa-icon
                                    [icon]="faAngleDoubleLeft"
                                    class="fa-1x move-item-icon"
                                    matTooltipPosition="right"
                                    matTooltipHideDelay="50"
                                    matTooltipClass="info-tooltip"></fa-icon>
                                Tout déplacer
                            </button>
                        }
                    </div>
                }
                <div class="drag-container">
                    <div class="drag-container-header"><span>Utilisateurs/groupes pour lequels il s'agit de la mise en page par défaut</span></div>
                    <div class="drop-list-container">
                        <div
                            id="accessibilities"
                            cdkDropList
                            cdkDropListSortingDisabled
                            [cdkDropListData]="accessibilities"
                            class="drop-list drop-target"
                            (cdkDropListDropped)="drop($event)"
                            [cdkDropListDisabled]="disabled">
                            @for (item of accessibilities; track item) {
                                <div class="drop-item list-layout-item" cdkDrag cdkDragPreview>
                                    @if (!disabled) {
                                        <fa-icon [icon]="faGripLinesVertical" class="fa-lg drag-handle" cdkDragHandle></fa-icon>
                                    }
                                    @if (item.userId) {
                                        <fa-icon [icon]="faUser" class="fa-1x type"></fa-icon>
                                        <span class="label">{{ item.userName }}</span>
                                    }
                                    @if (item.groupId) {
                                        <fa-icon [icon]="faUsers" class="fa-1x type"></fa-icon>
                                        <span class="label">{{ item.groupName }}</span>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    <div class="buttons-container">
        @if (!disabled) {
            <button mat-stroked-button class="accent-button" (click)="cancel()">Annuler</button>
        }
        <button mat-raised-button class="accent-button" (click)="$event.stopPropagation(); onExported()">Exporter</button>
        @if (!disabled) {
            <button mat-raised-button class="accent-button" (click)="$event.stopPropagation(); fileToUpload.click()">Importer</button>
            <button mat-raised-button class="accent-button" (click)="save()">Enregistrer</button>
        }
        <input ng2FileSelect #fileToUpload class="file-to-upload" type="file" [uploader]="uploader" (change)="onFileSelected()" [hidden]="true" />
    </div>
</div>
